console.clear();

import "@/scripts/global.css";
import "@/scripts/global.js";
import App from "@/App.vue";
import router from "@/scripts/router.js";
import store from "@/scripts/store.js";
import vuetify from "@/scripts/vuetify.js";
import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vue from "vue";

window.logMoovit("InYourPlace MAM", 100);


import FolderPermissionsDialog from "@/views/components/FolderPermissionsDialog.vue";
import AdminPanel from "@/views/components/AdminPanel.vue";
import UploadDialog from "@/views/components/UploadDialog.vue";
import DialogComponent from "@/views/components/DialogComponent.vue";
Vue.component("FolderPermissionsDialog", FolderPermissionsDialog);
Vue.component("AdminPanel", AdminPanel);
Vue.component("UploadDialog", UploadDialog);
Vue.component("DialogComponent", DialogComponent);

import DatePickerComponent from "@/views/components/DatePickerComponent.vue";
Vue.component("DatePickerComponent", DatePickerComponent);



import FolderBreadcrumb from "@/views/components/FolderBreadcrumb.vue";
Vue.component("FolderBreadcrumb", FolderBreadcrumb);

import MetadataSearch from "@/views/components/MetadataSearch.vue";
Vue.component("MetadataSearch", MetadataSearch);

import MetadataDisplay from "@/views/components/MetadataDisplay.vue";
Vue.component("MetadataDisplay", MetadataDisplay);

import SliderComponent from "@/views/components/SliderComponent.vue";
Vue.component("SliderComponent", SliderComponent);

import ClipDetails from "@/views/components/ClipDetails.vue";
Vue.component("ClipDetails", ClipDetails);

import TopBar from "@/views/components/TopBar.vue";
Vue.component("TopBar", TopBar);

import ClipComponent from "@/views/components/ClipComponent.vue";
Vue.component("ClipComponent", ClipComponent);

import AssetList from "@/views/lists/AssetList.vue";
Vue.component("AssetList", AssetList);

import AssetListItem from "@/views/listitems/AssetListItem.vue";
Vue.component("AssetListItem", AssetListItem);

import AssetThumbItem from "@/views/listitems/AssetThumbItem.vue";
Vue.component("AssetThumbItem", AssetThumbItem);

import CartList from "@/views/lists/CartList.vue";
Vue.component("CartList", CartList);

import CartListItem from "@/views/listitems/CartListItem.vue";
Vue.component("CartListItem", CartListItem);

import CartSubclipList from "@/views/lists/CartSubclipList.vue";
Vue.component("CartSubclipList", CartSubclipList);

import CartSubclipListItem from "@/views/listitems/CartSubclipListItem.vue";
Vue.component("CartSubclipListItem", CartSubclipListItem);

Vue.config.productionTip = false;

// window.setThemeColor("blueviolet");
// window.setThemeColor("44a5e0");

import { initKeycloak } from "@/scripts/keycloak.js";
import { setApiErrorReporter } from "@/scripts/apiErrors.js";

function mount() {
  // Route API failures to the existing dialog instead of only the console.
  setApiErrorReporter((message) => store.state.showErrorDialog(message));
  new Vue({ store, router, vuetify, render: (h) => h(App) }).$mount("#app");
}

// Authentication is Keycloak-only: nothing renders until there is a valid session.
initKeycloak().then(mount);
